import React from 'react'
import { Edit } from 'react-admin'
import UserForm from './UserForm'
import Toolbar from '../../components/FormToolbar'
import { transformData } from '../utils/helpers'

const EditUser = (props) => {
  return (
    <Edit
      {...props}
      toolbar={<Toolbar />}
      title='Редактирование пользователя'
      undoable={false}
      transform={transformData}
    >
      <UserForm {...props} isEdit />
    </Edit>
  )
}

export default EditUser
